<ntap-prime-common-itemview [class]="obrazacClass"></ntap-prime-common-itemview>
<ng-container *ngIf="(isDirectory$ | async)">
    <app-datoteke-lista viewName="direktorij_datoteke"></app-datoteke-lista>
</ng-container>